/**
 * Focus an element without scrolling the page.
 * Safari doesn't support `preventScroll` option in older versions,
 * so we fall back to regular focus if it throws.
 */
export function focusElementWithoutScroll(element: HTMLElement | null) {
  if (!element) return
  try {
    element.focus({ preventScroll: true })
  } catch {
    element.focus()
  }
}

/**
 * Restore the scroll position after an operation that may have caused a scroll jump.
 * Three calls needed: Radix resets scroll synchronously, Safari resets it
 * in a microtask, and some browsers reset it in the next animation frame.
 */
export function restoreScrollPosition(x: number, y: number) {
  const restore = () => window.scrollTo({ left: x, top: y })
  restore()
  setTimeout(restore, 0)
  requestAnimationFrame(restore)
}
